<template>
  <div v-if="offer" class="small text-left">
    <div class="row">
      <div class="col-4 mb-2">
        شماره :
        {{offer.number}}
      </div>
      <div class="col-4 mb-2">
        فروشنده :
        {{offer.seller}}
      </div>
      <div class="col-4 mb-2">
        تاریخ ثبت :
        {{offer.createdAt}}
      </div>
      <div class="col-4 mb-2">
        محصول :
        {{offer.product_title}}
      </div>
      <div class="col-4 mb-2">
        ویژگی :
        {{offer.attr_str}}
      </div>
      <div class="col-4 mb-2">
        کشور :
        {{offer.country_title}}
      </div>
      <div class="col-4 mb-2">
        برند :
        {{offer.brand_title}}
      </div>
      <div class="col-4 mb-2">
        وضعیت :
        <span v-html="offer.status"></span>
      </div>
    </div>
    <div v-if="offer.real_status === 'denied'" class="row h6">
      <div class="text-danger col-6" v-if="offer.reject_user_type === 'buyer'">رد شده توسط خریدار </div>
      <div class="text-danger col-6" v-else>رد شده توسط فروشنده </div>
      <div class="col-6">دلیل انتخاب شده برای رد کردن :
      <br>
        {{offer.reject_reason.title}}
      </div>
    </div>
    <div v-if="offer.price">
      <div class="text-left h6 font-weight-bold">پیشنهاد : </div>
      <div v-for="price in offer.prices" :key="price">
      <div class="text-danger mt-2 font-weight-bold">  برند :
        {{price.brand_title}}
       <template v-if="offer.confirmed_brand_id && price.brand_id === offer.confirmed_brand_id">
         &nbsp;&nbsp;<span class="text-success">(معامله شده)</span>
       </template>
      </div>
      <div class="table-responsive">
        <table class="table table-bordered table-sm">
          <thead>
          <tr>
            <th>نوع پرداخت</th>
            <th>مبلغ</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(p,index) in price.prices" :key="p">
            <td>{{p.title}}</td>
            <td><Money :number="p.price"></Money></td>
          </tr>
          </tbody>
        </table>
      </div>
      </div>
    </div>
    <div v-if="offer.bargain_history && offer.bargain_history.length">
      <div class="h6 font-weight-bold">تاریخچه مذاکره :</div>
      <div class="table-responsive">
        <table class="table table-bordered table-sm">
          <thead>
          <tr>
            <th>تاریخ</th>
            <th>کاربر</th>
            <th>تعداد</th>
            <th>شرایط پرداخت</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item) in offer.bargain_history" :key="item">
            <td dir="ltr">{{printDate(item.date)}}</td>
            <td>{{(item.user_type === 'seller'?'فروشنده':'خریدار')}}</td>
            <td>{{item.quantity}}</td>
            <td>
              <div v-for="(p,index ) in item.price" :key="p">{{p.title}} : <Money :number="p.price"></Money></div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-if="offer.is_transaction">
      <div class="h6 font-weight-bold">مشخصات معامله :</div>
      <div class="row">
        <div class="col-6">
          <div class="font-weight-bold">فروشنده </div>
          <div>وضعیت :
            <span v-html="offer.seller_status"></span>
          </div>
          <div>امتیاز به خریدار :
            <span class="font-weight-bold">{{offer.buyer_rate}}</span>
          </div>
          <div v-for="r in offer.buyer_rates" :key="r">
            {{r.title}} : <span class="font-weight-bold">{{r.rate}}</span>
          </div>
          <div class="alert alert-info" v-if="offer.buyer_review">
            نظر فروشنده نسبت به خریدار :
            <div v-html="offer.buyer_review"></div>
          </div>
        </div>
        <div class="col-6">
          <div class="font-weight-bold">خریدار </div>
          <div>وضعیت :
            <span v-html="offer.buyer_status"></span>
          </div>
          <div>امتیاز به فروشنده :
            <span class="font-weight-bold">{{offer.seller_rate}}</span>
          </div>
          <div v-for="r in offer.seller_rates" :key="r">
            {{r.title}} : <span class="font-weight-bold">{{r.rate}}</span>
          </div>
          <div class="alert alert-info" v-if="offer.seller_review">
            نظر خریدار نسبت به فروشنده :
            <div v-html="offer.seller_review"></div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Money from "@/components/Money";
import {dateInput} from "@/shared/helper";
export default {
name: "MarketRequestOfferInfoModal",
  components: {Money},
  props : ['offer'],
  methods : {
  printDate(date)
  {
    return dateInput(date,true);
  }
  }
}
</script>

<style scoped>

</style>